// extracted by mini-css-extract-plugin
module.exports = {"searchContainer":"styles_searchContainer__DYfoD","input":"styles_input__Plt85"};